import type { ModalAction, ModalState } from "./types";

export const INITIAL_MODAL_STATE: ModalState = {
  activeModal: null,
  payload: null,
};

export function modalReducer(
  state: ModalState,
  action: ModalAction
): ModalState {
  switch (action.type) {
    case "OPEN":
      return {
        activeModal: action.actionId,
        payload: action.payload,
      };
    case "CLOSE":
      return INITIAL_MODAL_STATE;
    default:
      return state;
  }
}
